import posthog from "posthog-js";

import { getActiveTraceContext } from "@atriam/observability";

import { toError } from "./to-error";
import { flattenCauseChain } from "./flatten-cause-chain";

const capturedErrors = new WeakSet<Error>();

/**
 * Send a client-side exception to PostHog error tracking. Use this at the
 * boundaries that swallow errors before they reach `window.onerror` —
 * React error boundaries and the TanStack Query/Mutation caches. Uncaught
 * errors and unhandled rejections are already autocaptured by the SDK
 * (`capture_exceptions` in posthog-config.ts).
 */
export function captureClientException(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  const err = toError(error);
  if (capturedErrors.has(err)) return;
  capturedErrors.add(err);
  const traceCtx = getActiveTraceContext();
  posthog.captureException(err, {
    ...context,
    // Without this the common `logger.error("label", { error: pgErr })` call
    // arrived carrying the label alone — no message, code, details or hint.
    ...flattenCauseChain(err),
    ...traceCtx,
    vercel_deployment_id: process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID,
  });
}
